export default "__VITE_ASSET__c4426253__"